import { isArray } from 'util';
import { mapCollection, sortByNumber } from '../../utils/collection.utils';
import { SaleOfferLineComplement } from '../sale-offer-line-complement';
import { parseNumber } from '../../utils/number.utils';

export class SaleOfferLineComplementBuilder {

  static fromJson(json): SaleOfferLineComplement {
    return (json) ? new SaleOfferLineComplement(
      json.hash,
      json.complementHash,
      json.complementName,
      json.complementCode,
      json.complementDescription,
      json.complementNeedSerialNumber,
      json.complementWeight,
      parseNumber(json.amount),
      parseNumber(json.totalAmount)
    ) : null;
  }

  static fromJsonList(list): SaleOfferLineComplement[] {
    return (isArray(list)) ? sortByNumber('amount', mapCollection(SaleOfferLineComplementBuilder.fromJson, list)) : [];
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/builders/sale-offer-line-complement-builder.ts